import { fromJS } from 'immutable';
// import { returnJS } from 'utils/helpers';

import {
    CREATE_OQ_CLIENT,
    CREATE_OQ_CLIENT_SUCCESS,
    CREATE_OQ_CLIENT_ERROR,
    CREATE_OQ_EMPLOYEE,
    CREATE_OQ_EMPLOYEE_SUCCESS,
    CREATE_OQ_EMPLOYEE_ERROR,
    DELETE_OQ_CLIENT,
    DELETE_OQ_CLIENT_SUCCESS,
    DELETE_OQ_CLIENT_ERROR,
    DELETE_OQ_EMPLOYEE,
    DELETE_OQ_EMPLOYEE_SUCCESS,
    DELETE_OQ_EMPLOYEE_ERROR,
    GET_OQ_PROFILE,
    GET_OQ_PROFILE_SUCCESS,
    GET_OQ_PROFILE_ERROR,
    GET_OQ_CLIENT,
    GET_OQ_CLIENT_SUCCESS,
    GET_OQ_CLIENT_ERROR,
    GET_OQ_ADMINISTRATION_URL,
    GET_OQ_ADMINISTRATION_URL_SUCCESS,
    GET_OQ_ADMINISTRATION_URL_ERROR,
    SEND_OQ_ADMINISTRATION_SMS,
    SEND_OQ_ADMINISTRATION_SMS_SUCCESS,
    SEND_OQ_ADMINISTRATION_SMS_ERROR,
    SEND_OQ_ADMINISTRATION_EMAIL,
    SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS,
    SEND_OQ_ADMINISTRATION_EMAIL_ERROR,
    GET_OQ_SCHEDULE,
    GET_OQ_SCHEDULE_SUCCESS,
    GET_OQ_SCHEDULE_ERROR,
    SET_OQ_SCHEDULE,
    SET_OQ_SCHEDULE_SUCCESS,
    SET_OQ_SCHEDULE_ERROR,
    STOP_OQ_SCHEDULE,
    STOP_OQ_SCHEDULE_SUCCESS,
    STOP_OQ_SCHEDULE_ERROR,
    GET_PATIENT_DEVICE_STATUS,
    GET_PATIENT_DEVICE_STATUS_SUCCESS,
    GET_PATIENT_DEVICE_STATUS_ERROR,
    SEND_OQ_ADMINISTRATION_PUSH,
    SEND_OQ_ADMINISTRATION_PUSH_SUCCESS,
    SEND_OQ_ADMINISTRATION_PUSH_ERROR,
} from './constants';
import { MeasuresActionTypes } from './types';

export const initialState = fromJS({
    hasOQAccount: false,
    isFetchingProfile: false,
    isCreatingClient: false,
    isCreatingEmployee: false,
    isDeletingClient: false,
    isDeletingEmployee: false,
    oqEmployeeDeleted: false,
    oqEmployeeDeleteReason: '',
    clientHasOQAccount: false,
    isFetchingClient: false,
    isFetchingURL: false,
    administrationURL: '',
    historyURL: '',
    recentQuestionnaireDate: '',
    isSendingSMS: false,
    deviceStatus: null,
    isLoadingDeviceStatus: false,
    deviceStatusError: false,
    isSendingPush: false,
    isSendingEmail: false,
    schedule: null,
    isLoadingSchedule: false,
    isSavingSchedule: false,
    errorMessage: '',
    successMessage: '',
});

import { getLogger } from 'utils/logger';
const logger = getLogger('v2.measures.reducer');

function measuresReducer(state = initialState, action: MeasuresActionTypes): typeof initialState {
    state = state.merge({
        errorMessage: '',
        successMessage: '',
    });

    switch (action.type) {
        case GET_OQ_CLIENT:
            logger.info('case GET_OQ_CLIENT');
            if (!action.data) return state;
            return state.merge({
                clientHasOQAccount: false,
                isFetchingClient: true,
            });
        case GET_OQ_CLIENT_SUCCESS:
            logger.info('case GET_OQ_CLIENT_SUCCESS');
            return state.merge({
                clientHasOQAccount: true,
                isFetchingClient: false,
                // administrationURL: action.data.adminURL,
                administrationURL: '',
                historyURL: action.data.historyURL,
                recentQuestionnaireDate: action.data.recentQuestionnaireDate,
            });
        case GET_OQ_CLIENT_ERROR:
            logger.info('case GET_OQ_CLIENT_ERROR');
            return state.merge({
                clientHasOQAccount: false,
                isFetchingClient: false,
                // errorMessage: action.data,
            });
        case GET_OQ_PROFILE:
            logger.info('case GET_OQ_PROFILE');
            return state.merge({
                hasOQAccount: false,
                isFetchingProfile: true,
            });
        case GET_OQ_PROFILE_SUCCESS:
            logger.info('case GET_OQ_PROFILE_SUCCESS');
            return state.merge({
                hasOQAccount: true,
                isFetchingProfile: false,
            });
        case GET_OQ_PROFILE_ERROR:
            logger.info('case GET_OQ_PROFILE_ERROR');
            return state.merge({
                hasOQAccount: false,
                isFetchingProfile: false,
                // errorMessage: action.data,
            });
        case CREATE_OQ_CLIENT:
            logger.info('case CREATE_OQ_CLIENT');
            return state.set('isCreatingClient', true);
        case CREATE_OQ_CLIENT_SUCCESS:
            logger.info('case CREATE_OQ_CLIENT_SUCCESS');
            return state.merge({
                isCreatingClient: false,
                successMessage: 'Client created successfully',
            });
        case CREATE_OQ_CLIENT_ERROR:
            logger.info('case CREATE_OQ_CLIENT_ERROR');
            return state.merge({
                isCreatingClient: false,
                errorMessage: action.data,
            });
        case CREATE_OQ_EMPLOYEE:
            logger.info('case CREATE_OQ_EMPLOYEE');
            return state.set('isCreatingEmployee', true);
        case CREATE_OQ_EMPLOYEE_SUCCESS:
            logger.info('case CREATE_OQ_EMPLOYEE_SUCCESS');
            return state.merge({
                isCreatingEmployee: false,
                successMessage: 'Employee created successfully',
            });
        case CREATE_OQ_EMPLOYEE_ERROR:
            logger.info('case CREATE_OQ_EMPLOYEE_ERROR');
            return state.merge({
                isCreatingEmployee: false,
                errorMessage: action.data,
            });
        case DELETE_OQ_CLIENT:
            logger.info('case DELETE_OQ_CLIENT');
            return state.set('isDeletingClient', true);
        case DELETE_OQ_CLIENT_SUCCESS:
            logger.info('case DELETE_OQ_CLIENT_SUCCESS');
            return state.merge({
                isDeletingClient: false,
                clientHasOQAccount: false,
                historyURL: '',
                recentQuestionnaireDate: '',
                successMessage: 'OQ45 client account deleted.',
            });
        case DELETE_OQ_CLIENT_ERROR:
            logger.info('case DELETE_OQ_CLIENT_ERROR');
            return state.merge({
                isDeletingClient: false,
                errorMessage: action.data,
            });
        case DELETE_OQ_EMPLOYEE:
            logger.info('case DELETE_OQ_EMPLOYEE');
            // Reset the prior verify outcome so a stale result can't leak into the
            // next attempt's true->false transition that the modal watches.
            return state.merge({
                isDeletingEmployee: true,
                oqEmployeeDeleted: false,
                oqEmployeeDeleteReason: '',
            });
        case DELETE_OQ_EMPLOYEE_SUCCESS: {
            logger.info('case DELETE_OQ_EMPLOYEE_SUCCESS');
            const { result } = action.data;
            const { deleted } = result;
            const reason = result.reason || '';
            // Admin portal-then-verify: every non-error outcome lands here. A real
            // deletion and an idempotent "already gone" (no-mapping) are both success
            // end states; a still-present result is surfaced inline by the modal and
            // gets no toast. Keep {deleted, reason} so the modal classifies the
            // outcome structurally instead of sniffing message strings.
            let successMessage = '';
            if (deleted) {
                successMessage = 'OQ45 employee account deleted.';
            } else if (reason === 'no-mapping') {
                successMessage = 'OQ45 employee account already removed.';
            }
            return state.merge({
                isDeletingEmployee: false,
                oqEmployeeDeleted: deleted,
                oqEmployeeDeleteReason: reason,
                successMessage,
            });
        }
        case DELETE_OQ_EMPLOYEE_ERROR:
            logger.info('case DELETE_OQ_EMPLOYEE_ERROR');
            return state.merge({
                isDeletingEmployee: false,
                errorMessage: action.data,
            });
        case GET_OQ_ADMINISTRATION_URL:
            logger.info('case GET_OQ_ADMINISTRATION_URL');
            return state.merge({
                isFetchingURL: true,
                administrationURL: '',
            });
        case GET_OQ_ADMINISTRATION_URL_SUCCESS:
            logger.info('case GET_OQ_ADMINISTRATION_URL_SUCCESS');
            // No toast: the URL is generated silently whenever the dialog opens or the
            // measure changes (MTC-144), so a "created" toast fired on every open.
            return state.merge({
                isFetchingURL: false,
                administrationURL: action.data,
            });
        case GET_OQ_ADMINISTRATION_URL_ERROR:
            logger.info('case GET_OQ_ADMINISTRATION_URL_ERROR');
            return state.merge({
                isFetchingURL: false,
                errorMessage: action.data,
            });
        case SEND_OQ_ADMINISTRATION_SMS:
            logger.info('case SEND_OQ_ADMINISTRATION_SMS');
            return state.merge({ isSendingSMS: true });
        case SEND_OQ_ADMINISTRATION_SMS_SUCCESS:
            logger.info('case SEND_OQ_ADMINISTRATION_SMS_SUCCESS');
            return state.merge({
                isSendingSMS: false,
                successMessage: 'SMS sent successfully',
            });
        case SEND_OQ_ADMINISTRATION_SMS_ERROR:
            logger.info('case SEND_OQ_ADMINISTRATION_SMS_ERROR');
            return state.merge({
                isSendingSMS: false,
                errorMessage: action.data,
            });
        case SEND_OQ_ADMINISTRATION_EMAIL:
            logger.info('case SEND_OQ_ADMINISTRATION_EMAIL');
            return state.merge({ isSendingEmail: true });
        case SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS:
            logger.info('case SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS');
            return state.merge({
                isSendingEmail: false,
                successMessage: 'Email sent successfully',
            });
        case SEND_OQ_ADMINISTRATION_EMAIL_ERROR:
            logger.info('case SEND_OQ_ADMINISTRATION_EMAIL_ERROR');
            return state.merge({
                isSendingEmail: false,
                errorMessage: action.data,
            });
        case GET_OQ_SCHEDULE:
            logger.info('case GET_OQ_SCHEDULE');
            return state.merge({ isLoadingSchedule: true });
        case GET_OQ_SCHEDULE_SUCCESS:
            logger.info('case GET_OQ_SCHEDULE_SUCCESS');
            return state.merge({
                isLoadingSchedule: false,
                schedule: action.data,
            });
        case GET_OQ_SCHEDULE_ERROR:
            logger.info('case GET_OQ_SCHEDULE_ERROR');
            return state.merge({
                isLoadingSchedule: false,
                errorMessage: action.data,
            });
        case SET_OQ_SCHEDULE:
            logger.info('case SET_OQ_SCHEDULE');
            return state.merge({ isSavingSchedule: true });
        case SET_OQ_SCHEDULE_SUCCESS:
            logger.info('case SET_OQ_SCHEDULE_SUCCESS');
            return state.merge({
                isSavingSchedule: false,
                schedule: action.data,
                successMessage: 'Automated schedule saved',
            });
        case SET_OQ_SCHEDULE_ERROR:
            logger.info('case SET_OQ_SCHEDULE_ERROR');
            return state.merge({
                isSavingSchedule: false,
                errorMessage: action.data,
            });
        case STOP_OQ_SCHEDULE:
            logger.info('case STOP_OQ_SCHEDULE');
            return state.merge({ isSavingSchedule: true });
        case STOP_OQ_SCHEDULE_SUCCESS:
            logger.info('case STOP_OQ_SCHEDULE_SUCCESS');
            return state.merge({
                isSavingSchedule: false,
                schedule: null,
                successMessage: 'Automated schedule stopped',
            });
        case STOP_OQ_SCHEDULE_ERROR:
            logger.info('case STOP_OQ_SCHEDULE_ERROR');
            return state.merge({
                isSavingSchedule: false,
                errorMessage: action.data,
            });

        case GET_PATIENT_DEVICE_STATUS:
            // The dialog is reused across patients: drop the previous patient's
            // status so it can never enable the button for the next one.
            logger.info('case GET_PATIENT_DEVICE_STATUS');
            return state.merge({ isLoadingDeviceStatus: true, deviceStatus: null, deviceStatusError: false });
        case GET_PATIENT_DEVICE_STATUS_SUCCESS:
            logger.info('case GET_PATIENT_DEVICE_STATUS_SUCCESS');
            return state.merge({
                isLoadingDeviceStatus: false,
                deviceStatus: action.data,
            });
        case GET_PATIENT_DEVICE_STATUS_ERROR:
            // A failed status read only means the button stays disabled; it is
            // not worth a toast while the admin is trying to send an SMS.
            logger.info('case GET_PATIENT_DEVICE_STATUS_ERROR');
            return state.merge({ isLoadingDeviceStatus: false, deviceStatusError: true });
        case SEND_OQ_ADMINISTRATION_PUSH:
            logger.info('case SEND_OQ_ADMINISTRATION_PUSH');
            return state.merge({ isSendingPush: true });
        case SEND_OQ_ADMINISTRATION_PUSH_SUCCESS:
            logger.info('case SEND_OQ_ADMINISTRATION_PUSH_SUCCESS');
            return state.merge({
                isSendingPush: false,
                successMessage: "Sent to the patient's iPhone app",
            });
        case SEND_OQ_ADMINISTRATION_PUSH_ERROR:
            logger.info('case SEND_OQ_ADMINISTRATION_PUSH_ERROR');
            return state.merge({
                isSendingPush: false,
                errorMessage: action.data,
            });

        default:
            return state;
    }
};

export default measuresReducer;
